import styles from "./PlayersFilters.module.css"
import { useState } from "react"
import { LengthPlayer } from "../lib/players"
interface Props {
  filter: any
  total: LengthPlayer | null
}
function PlayersFilters(props: Props) {
  const [selected, setSelected] = useState("all")
  function onChangeHandler(value: string) {
    if (value) {
      setSelected(value)
      props.filter(format(value))
    }
  }
  function format(value: string): boolean | null {
    if (value === "online") {
      return true
    }
    if (value === "offline") {
      return false
    }
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.item + " " + `${selected === "all" ? styles.all_selected : styles.all}`} onClick={() => onChangeHandler("all")}>
        <span className={styles.number}>{props.total?.all ? props.total?.all : 0}</span>
        <span className={styles.text}>All</span>
      </div>
      <div className={styles.item + " " + `${selected === "online" ? styles.online_selected : styles.online}`} onClick={() => onChangeHandler("online")}>
        <span className={styles.number}>{props.total?.online ? props.total?.online : 0}</span>
        <span className={styles.text}>Online</span>
      </div>
      <div className={styles.item + " " + `${selected === "offline" ? styles.offline_selected : styles.offline}`} onClick={() => onChangeHandler("offline")}>
        <span className={styles.number}>{props.total?.off ? props.total?.off : 0}</span>
        <span className={styles.text}>Offline</span>
      </div>
    </div>
  )
}

export default PlayersFilters
